import Repository from "./Repository"

export default {
  /**
   * Get All Treatments
   * @param Integer page
   * @param Integer limit
   */
  getAllTreatments(page, limit, circle) {
    return Repository.get(`/alltreatments/?page_num=${page}&items=${limit}&value=${circle}`)
  },

  /**
   * Get Treatment
   * @param Integer id
   * @param Integer page
   * @param Integer limit
   */
  getTreatment(id, circle, page = 1, limit = 1) {
    return Repository.get(`/alltreatments/?id=${id}&page_num=${page}&items=${limit}&circle_id=${circle}`)
  },

  getOtherTreatment(id, circle, page = 1, limit = 1) {
    return Repository.get(`/extratreatment/?id=${id}&page_num=${page}&items=${limit}&circle_id=${circle}`)
  },

  /**
   * Search Treatments
   *
   * @param String query
   * @param Integer page
   * @param Integer limit
   */
  searchTreatments(query = "", circleId, type, page, limit = 16, proSubType, cancelToken) {
    const c = circleId !== undefined ? `&circle_id=${circleId}` : ""
    const t = type !== undefined ? `&treatment_type=${type}` : ""
    const pst = type === "Procedure" && proSubType ? `&sub_type=${proSubType}` : ""
    return Repository.get(
      `/treatmentsearch/?key=${query}&items=${limit}&page_num=${page}` + c + t + pst
      // `/treatmentsearch/?key=${query}&items=10&page_num=${page}` + c + t
    )
  },

  /**
   * Search Symptoms
   * @param String query
   */
  searchSymptoms(query, currentCircle) {
    return Repository.get(`/symptomsearch/?key=${query}&circle_id=${currentCircle.id}`)
  },

  /**
   *
   * Search nonmedicaltreatments
   */
  searchNonmedicaltreatments(search, circle, id, page, limit = 16) {
    const searchKey = search ? `&key=${search}` : ""
    const idKey = id ? `&id=${id}` : ""
    const pageNum = page ? `&page_num=${page}` : ""
    const circleId = circle ? `&circle_id=${circle}` : ""
    return Repository.get(`/nonmedicaltreatments/?items=${limit}` + searchKey + idKey + pageNum + circleId)
  },

  /*
    get interests
  */
  getInterests(search) {
    const s = search ? `&key=${search}` : ""
    return Repository.get(`interests/?page_num=1&items=10` + s)
  },

  /**
   *  Get Recently Trending Circle Members
   *
   * @param Integer currentCircle
   */
  getRecentlyTrending(currentCircle) {
    return Repository.get(`/currentlytrending/?circle_id=${currentCircle.id}`)
  },

  /**
   *  Get Recently Joined Circle Members
   *
   * @param Integer currentCircle
   */
  getRecentlyJoined(currentCircle) {
    return Repository.get(`/recentlyjoined/?circle_id=${currentCircle.id}`)
  },

  /**
   *  Get Recently Reviewed Circle Members
   *
   * @param Integer currentCircle
   */
  getRecentlyReviewed(currentCircle) {
    return Repository.get(`/recentlyreviewed/?circle_id=${currentCircle.id}`)
  },

  getOtherConditions(val) {
    const search = val ? `?key=${val}` : ""
    return Repository.get(`/otherconditions/` + search)
  },

  /**
   * Get notifications
   * @param {integer} page
   * @param {integer} limit
   */
  getNotifications(circleId, page, limit, user) {
    return Repository.get(`/notifications/?user_id=${user.id}&circle_id=${circleId}&page_num=${page}&items=${limit}&sort_by=-created_at`)
  },
  readNotifications(id) {
    return Repository.put(`/notifications/?id=${id}`, { is_read: true })
  },

  allNotificationsChecked(user, circle_id) {
    return Repository.put(`/notifications/?user_id=${user.id}&role=${user.role}&circle_id=${circle_id}`)
  },

  /**
   * Get backgound Image
   */
  getImageCategories() {
    return Repository.get(`/mastertable/?type=image`)
  },

  getImageSubCategories(id) {
    return Repository.get(`/mastertable/?type=image&code=Avatar`)
  },
  getBgSubCategories(id) {
    return Repository.get(`/mastertable/?type=image&code=Background`)
  },

  getBackgroundImageGallery(type = null) {
    return Repository.get(`/backgroundimage/${type ? `?image_type_id=${type}` : ""}`)
  },

  getAllAdvocates(role, page, items, circleId, val, age, gender, filter_page_num) {
    const Role = role ? `&role=${role}` : ""
    const filterpagenum = filter_page_num ? `&page_num=${filter_page_num}` : ""
    const filter_age = age ? `&age=${age}` : ""
    const filter_gender = gender ? `&gender=${gender}` : ""
    const location = val ? `&location=${val}` : ""
    const pageNum = page ? `?page_num=${page}` : ""
    const itemNum = items ? `&items=${items}` : ""
    const circle_id = circleId ? `&circle_id=${circleId}` : ""
    const user_role = role ? `&role=${role}` : ""
    return Repository.get(`/advocate/${pageNum}${itemNum}${circle_id}${location}${filter_age}${filter_gender}${filterpagenum}${Role}`)
  },

  memberSearch(page, limit, circleId, sort, params) {
    return Repository.get(`/membersearch/?page_num=${page}&items=${limit}&circle_id=${circleId}&sort=${sort}`, { params })
  },

  shareSearch(params) {
    return Repository.get(`/share/`, { params })
  },

  /**
   * Send contact us data
   *
   * @param {json} payload
   */
  contactForm(payload) {
    return Repository.post(`/contactus/`, payload)
  },

  /**
   * Get Relationship Status values
   */
  getRelationShipStatusValues() {
    return Repository.get(`/mastertable/?type=relationship`)
  },

  /**
   * Get Current Situation values
   */
  getCurrentSituationValues() {
    return Repository.get(`/mastertable/?type=current_situation`)
  },

  /**
   * Get Current Situation values
   */
  getSpecialities() {
    return Repository.get(`/mastertable/?type=speciality`)
  },

  /**
   * Get Countries
   */
  getLocations(city) {
    return Repository.get(`/masterlocations/?page_num=1&items=10&city=${city}`)
  },
  /**
   * Get Countries
   */
  getAllCountries() {
    return Repository.get(`/mastertable/?type=country`)
  },

  postFeedBack(payload) {
    return Repository.post(`/feedback/`, payload)
  },
  getSupportSubject() {
    return Repository.get(`/subject`)
  },

  /**
   * Get States
   */
  getAllStates() {
    return [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ]
  },

  /**
   * Resend Verification Email
   */
  resendVerificationEmail(data) {
    return Repository.post(`/signupresend/`, data)
  },
  getHasMultiRole(id) {
    return Repository.get(`/hasmultirole/?circle_id=${id}`)
  },
  postHasMultiRole(data) {
    return Repository.post(`/hasmultirole/`, data)
  },
  enterCircleForMultiRole(payload) {
    return Repository.post(`/ssoregister/`, payload)
  },
  ssoMultiRoleLogin(payload) {
    return Repository.post(`/multirolejoin/`, payload)
  },

  getAddons(key = "", circle_id) {
    return Repository.get(`/addonssearch/?key=${key}&circle_id=${circle_id}`)
  },
}



// WEBPACK FOOTER //
// ./src/repositories/appRepository.js